import React from "react";
import { useNavigate } from "react-router-dom";
import logo from "../../assets/logo.png";

// images from public folder
const Hero1 = `${process.env.PUBLIC_URL}/assets/HeroAni/hero1.webp`;
const Hero2 = `${process.env.PUBLIC_URL}/assets/HeroAni/hero2.webp`;
const Hero3 = `${process.env.PUBLIC_URL}/assets/HeroAni/hero3.webp`;
const Hero4 = "https://i.ibb.co/SD07wCwK/dashboard.jpg";

const HomeHero = () => {
  const navigate = useNavigate();

  const handleDemoButtonClick = (params) => {
    navigate("/contact-us");
  };

  return (
    <div
      id="hero"
      className="bg-[#FAF8F7] min-h-screen flex items-center font-[400] text-[#273720] font-tahoma overflow-hidden -mt-[72px] pt-[72px]"
    >
      <div className="w-full max-w-7xl mx-auto px-4 md:px-8 lg:px-16 py-12 md:py-20 lg:py-16">
        <div className="flex flex-col md:flex-row items-center justify-between gap-8 md:gap-12 lg:gap-16">
          <div className="w-full md:w-[584px] lg:w-[650px] text-center md:text-left space-y-6 md:space-y-10">
            <div className="space-y-5 md:space-y-6">
              <div>
                <div className="flex items-center gap-3 md:gap-4 justify-center md:justify-start mb-4">
                  <img 
                    src={logo} 
                    alt="TwoKey Logo" 
                    className="h-12 md:h-14 lg:h-16 w-auto object-contain"
                  />
                  <h1 className="text-5xl md:text-6xl lg:text-7xl font-bold leading-tight text-[#273720]">
                    Twokey
                  </h1>
                </div>
                <div className="h-1.5 bg-gradient-to-r from-[#5E5ADB] to-[#C8C6FF] rounded-full w-32 md:w-40 mx-auto md:mx-0"></div>
              </div>
              <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold bg-gradient-to-r from-[#5E5ADB] to-[#C8C6FF] bg-clip-text text-transparent leading-tight">
                The one stop workplace
              </h2>
              <p className="text-lg md:text-xl text-gray-600 leading-relaxed max-w-xl">
              Unify your document, communication and collaboration workflows from one site seamlessly. Create, store share and manage all your work from just one site
              </p>
            </div>
            <div className="flex flex-col sm:flex-row gap-4 items-center md:items-start">
              <button
                onClick={handleDemoButtonClick}
                className="bg-gradient-to-r from-[#5E5ADB] to-[#7B6FE8] hover:from-[#4E4ACB] hover:to-[#6B5FD8] text-white rounded-xl py-3 px-8 md:py-3.5 md:px-10 text-sm md:text-base font-semibold shadow-xl hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-1 hover:scale-105"
              >
                Get started
              </button>
              <button
                onClick={() => document.getElementById('product')?.scrollIntoView({ behavior: 'smooth' })}
                className="bg-transparent border-2 border-[#5E5ADB] text-[#5E5ADB] hover:bg-[#5E5ADB] hover:text-white rounded-xl py-3 px-8 md:py-3.5 md:px-10 text-sm md:text-base font-semibold transition-all duration-300 transform hover:-translate-y-1"
              >
                Learn more
              </button>
            </div>
          </div>

          <div className="w-full md:w-auto flex-shrink-0 flex items-center justify-center">
            <div className="relative w-full max-w-md md:max-w-lg lg:max-w-xl">
              <div className="absolute inset-0 bg-gradient-to-br from-[#C8C6FF]/20 to-[#5E5ADB]/10 rounded-3xl blur-3xl transform rotate-6"></div>
              <img
                src={Hero4}
                alt="TwoKey Platform"
                className="relative w-full h-auto object-contain drop-shadow-2xl transform hover:scale-105 transition-transform duration-500 rounded-2xl"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HomeHero;
